import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {action} from 'mobx';
import {inject} from 'mobx-react';
import classie from 'classie';
import autobind from 'autobind-decorator';

@inject(({store: {tracker, screen}}) => (
  {tracker, screen}
))
class RenderToContextual extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    greenMode: PropTypes.bool,
    mediumWidth: PropTypes.bool,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    screen: PropTypes.shape({
      isMenuAnimating: PropTypes.bool,
    }).isRequired,
    onClose: PropTypes.func,
    className: PropTypes.string,
  }

  componentDidMount() {
    const {greenMode} = this.props;

    this.entryPoint = document.getElementById('js-context-entry-point');
    this.contextMenu = !greenMode ? document.getElementById('js-context-menu') : document.getElementById('js-context-menu-green');
    this.contextualMenu = !greenMode ? document.getElementById('js-context-overlay') : document.getElementById('js-context-overlay-green');
    this.setMenuIsAnimating();
    this.contextMenu.addEventListener('transitionend', this.setMenuIsNotAnimating, false);
    classie.add(this.contextMenu, 'contextualMenu__panel--open');

    if (this.props.className) {
      classie.add(this.contextMenu, this.props.className);
    }

    if (this.props.mediumWidth && this.props.mediumWidth === true) {
      classie.add(this.contextMenu, 'contextualMenu__panel--medium-width');
    }

    classie.add(this.contextualMenu, 'open');
    classie.add(document.body, 'no-scroll-contextual');
    this._renderChildren();

    if ('touchend' in document.documentElement) {
      this.contextualMenu.addEventListener('touchend', this.clickOutsideToClose);
    } else if (this.contextualMenu.addEventListener) {
      this.contextualMenu.addEventListener('click', this.clickOutsideToClose);
    } else {
      this.contextualMenu.attachEvent('click', this.clickOutsideToClose);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    this.contextMenu.removeEventListener('transitionend', this.setMenuIsNotAnimating);
    classie.remove(this.contextMenu, 'contextualMenu__panel--open');
    classie.remove(this.contextMenu, 'contextualMenu__panel--medium-width');
    classie.remove(this.contextualMenu, 'open');
    classie.remove(this.contextMenu, 'contextualMenu__panel--anim-over');
    classie.remove(document.body, 'no-scroll-contextual');

    if (this.props.className) {
      classie.remove(this.contextMenu, this.props.className);
    }

    ReactDOM.unmountComponentAtNode(this.entryPoint);

    if ('touchend' in document.documentElement) {
      this.contextualMenu.removeEventListener('touchend', this.clickOutsideToClose);
    } else if (this.contextualMenu.removeEventListener) {
      this.contextualMenu.removeEventListener('click', this.clickOutsideToClose);
    } else {
      this.contextualMenu.detachEvent('click', this.clickOutsideToClose);
    }
  }

  /*
  * Close the contextual menu if clicked outside
  */
  clickOutsideToClose = (event) => {
    const {onClose} = this.props;
    if (event.target === document.getElementById('js-context-overlay')) {
      classie.remove(this.contextMenu, 'contextualMenu__panel--open');
      classie.remove(this.contextMenu, 'contextualMenu__panel--medium-width');
      classie.remove(this.contextualMenu, 'open');
      classie.remove(this.contextMenu, 'contextualMenu__panel--anim-over');
      classie.remove(document.body, 'no-scroll-contextual');

      this.props.tracker.track('Closed Panel by Clicking Overlay', {
        category: 'Booking',
      });
      onClose();
      ReactDOM.unmountComponentAtNode(this.entryPoint);
    }
  }

  /*
  * Set our screen state to track the trasition start of our menu
  */
  @autobind
  @action('setMenuIsAnimating - RenderToContextual')
  setMenuIsAnimating() {
    const {screen} = this.props;
    screen.isMenuAnimating = true;
  }

  /*
  * Set our screen state to track the trasition end of our menu
  */
  @autobind
  @action('setMenuIsAnimating - RenderToContextual')
  setMenuIsNotAnimating() {
    const {screen} = this.props;
    screen.isMenuAnimating = false;
    classie.add(this.contextMenu, 'contextualMenu__panel--anim-over');
  }

  _renderChildren() {
    ReactDOM.unstable_renderSubtreeIntoContainer(this, this.props.children, this.entryPoint);
  }

  render() {
    return null;
  }
}

export default RenderToContextual;



// WEBPACK FOOTER //
// ./spa/Components/RenderToContextual.jsx